// 📁 Imports

// 💾 Variables
// const alertsCloseButton = document.querySelectorAll("[data-alert-close]");
const modal = document.querySelector("[data-modal]");
import { getTranslateData } from "@/utils/translator.js";

// 📐 Functions
const modalShow = (el) => {
  console.log(el.dataset);
  if (el.dataset.modal) {
    el.dataset.modal = "show";
  }
};

const modalHide = (el) => {
  if (el.dataset.modal) {
    el.dataset.modal = "hide";
  }
};

const modalUpdateMessage = (el, messages) => {
  const allSections = el.querySelectorAll("[data-modal-section]");
  allSections.forEach((section) => {
    section.style.display = "none";
  });

  const sectionTypes = ["success", "error", "info", "warning"];

  sectionTypes.forEach((type) => {
    const section = el.querySelector(`[data-modal-${type}-section]`);
    const list = messages[type];

    if (section && Array.isArray(list) && list.length > 0) {
      const messageList = section.querySelector("[data-modal-list]");
      const ul = document.createElement("ul");

      list.forEach((message) => {
        const li = document.createElement("li");
        li.textContent = getTranslateData(message);
        ul.appendChild(li);
      });

      messageList.innerHTML = "";
      messageList.appendChild(ul);
      section.style.display = "";
    }
  });
};

// 🖱️ Event listener
if (modal) {
  const overlay = modal.querySelector("[data-modal-overlay]");
  const button = modal.querySelector("[data-modal-close ]");

  overlay.addEventListener("click", (e) => {
    const modal = e.target.closest("[data-modal]");
    modalHide(modal);
  });

  button.addEventListener("click", (e) => {
    const modal = e.target.closest("[data-modal]");
    modalHide(modal);
  });
}

// 📤 Export
export { modalShow, modalHide, modalUpdateMessage };
